import type { FeatureFlag } from '@risksmart-app/modules/src/index';

/**
 * Per-entity Smart Copy descriptor for Indicators — the single source of truth
 * for the Indicator tab's gate + tooltip wording. Mirrors
 * `controlTestSmartCopy.ts`.
 *
 * - `flagKey` — per-org feature flag (`Meta.features`), read via
 *   `useIsFeatureFlagEnabled`; typed against the feature-flag registry.
 * - `eventLabel` — prefixes the Amplitude event names (capitalised); 'Indicator'
 *   reproduces the deployed sister-convention (Control Test) event strings.
 * - `entityNoun` — interpolates into the disabled tooltip (lowercase).
 */
export const INDICATOR_SMART_COPY = {
  flagKey: 'smart_copy_indicator' satisfies FeatureFlag,
  eventLabel: 'Indicator',
  entityNoun: 'indicator',
} as const;
